import { __extends } from "tslib";
import { AbstractMethodError, AbstractionBase, TransformEvent } from '@awayjs/core';
import { BoundsPickerEvent } from '../events/BoundsPickerEvent';
import { ContainerNodeEvent } from '../events/ContainerNodeEvent';
var BoundingVolumeBase = /** @class */ (function (_super) {
    __extends(BoundingVolumeBase, _super);
    //protected _boundsPrimitive:Sprite;
    function BoundingVolumeBase(asset, pool) {
        var _this = _super.call(this, asset, pool) || this;
        _this._targetCoordinateSpace = asset;
        _this._picker = pool.picker;
        _this._strokeFlag = pool.strokeFlag;
        _this._fastFlag = pool.fastFlag;
        _this._onInvalidateBoundsDelegate = function (event) { return _this._onInvalidateBounds(event); };
        _this._onInvalidateMatrix3DDelegate = function (event) { return _this._onInvalidateMatrix3D(event); };
        _this._picker.addEventListener(BoundsPickerEvent.INVALIDATE_BOUNDS, _this._onInvalidateBoundsDelegate);
        if (_this._targetCoordinateSpace != _this._picker.node) {
            var targetEntity = _this._picker.node;
            while (targetEntity && targetEntity != _this._targetCoordinateSpace) {
                targetEntity.container.transform.addEventListener(TransformEvent.INVALIDATE_MATRIX3D, _this._onInvalidateMatrix3DDelegate);
                targetEntity = targetEntity.parent;
            }
            if (!targetEntity) //case when targetCoordinateSpace is not part of the same displaylist ancestry
                _this._targetCoordinateSpace.addEventListener(ContainerNodeEvent.INVALIDATE_MATRIX3D, _this._onInvalidateMatrix3DDelegate);
        }
        return _this;
    }
    BoundingVolumeBase.prototype._onInvalidateBounds = function (event) {
        this._invalid = true;
    };
    BoundingVolumeBase.prototype._onInvalidateMatrix3D = function (event) {
        this._invalid = true;
    };
    BoundingVolumeBase.prototype.onClear = function (event) {
        _super.prototype.onClear.call(this, event);
        this._picker.removeEventListener(BoundsPickerEvent.INVALIDATE_BOUNDS, this._onInvalidateBoundsDelegate);
        if (this._targetCoordinateSpace != this._picker.node) {
            var targetEntity = this._picker.node;
            while (targetEntity && targetEntity != this._targetCoordinateSpace) {
                targetEntity.container.transform.removeEventListener(TransformEvent.INVALIDATE_MATRIX3D, this._onInvalidateMatrix3DDelegate);
                targetEntity = targetEntity.parent;
            }
            if (!targetEntity) //case when targetCoordinateSpace is not part of the same displaylist ancestry
                this._targetCoordinateSpace.removeEventListener(ContainerNodeEvent.INVALIDATE_MATRIX3D, this._onInvalidateMatrix3DDelegate);
        }
        this._targetCoordinateSpace = null;
        this._picker = null;
        //this._boundsPrimitive = null;
    };
    // public get boundsPrimitive():DisplayObject
    // {
    // 	if (this._boundsPrimitive == null) {
    // 		this._boundsPrimitive = this._createBoundsPrimitive();
    // 		this._invalid = true;
    // 	}
    // 	if(this._invalid)
    // 		this._update();
    // 	this._boundsPrimitive.transform.matrix3D = this._boundingEntity.transform.concatenatedMatrix3D;
    // 	return this._boundsPrimitive;
    // }
    BoundingVolumeBase.prototype.nullify = function () {
        throw new AbstractMethodError();
    };
    BoundingVolumeBase.prototype.isInFrustum = function (planes, numPlanes) {
        throw new AbstractMethodError();
    };
    BoundingVolumeBase.prototype.clone = function () {
        throw new AbstractMethodError();
    };
    BoundingVolumeBase.prototype.rayIntersection = function (position, direction, targetNormal) {
        return -1;
    };
    BoundingVolumeBase.prototype.classifyToPlane = function (plane) {
        throw new AbstractMethodError();
    };
    BoundingVolumeBase.prototype._update = function () {
        this._invalid = false;
    };
    return BoundingVolumeBase;
}(AbstractionBase));
export { BoundingVolumeBase };
